// src/index.js
import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

import { PostHogCtx } from './utils/PostHogContext';   // stub we made in Step 3b
import { loadWhenIdle } from './utils/loadWhenIdle';       // tiny helper from Step 0

/* ------------------------------------------------------------------
   1. Environment variables (unchanged)
------------------------------------------------------------------ */
const POSTHOG_KEY  = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;

/* ------------------------------------------------------------------
   2. Lazy wrapper that loads PostHog only when the browser is idle
------------------------------------------------------------------ */
function LazyAnalytics({ children }) {
  const [ph, setPh] = useState(null);               // will hold the real client

  useEffect(() => {
    if (!POSTHOG_KEY) {
      console.warn(
        '[PostHog] Env var REACT_APP_PUBLIC_POSTHOG_KEY missing – analytics disabled.'
      );
      return;                                       // nothing to load
    }

    loadWhenIdle(async () => {
      const { default: posthog } = await import('posthog-js');   // creates its own chunk
      posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        capture_pageview : true,
        capture_pageleave: true,
        session_recording: {},                      // replay ON
      });
      setPh(() => posthog);                         // swap stub → real
    });
  }, []);

  // Until PostHog loads we expose a safe no-op client
  const ctxValue = ph || { capture: () => {} };

  return (
    <PostHogCtx.Provider value={ctxValue}>
      {children}
    </PostHogCtx.Provider>
  );
}

/* ------------------------------------------------------------------
   3. Bootstrap React
------------------------------------------------------------------ */
const root = createRoot(document.getElementById('root'));

root.render(
  <LazyAnalytics>
    <App />
  </LazyAnalytics>
);
